import { Box } from "@chakra-ui/react";
import { ColorIcon, Spacing } from "goi_common";
import { baseColors, BaseButton, BaseStack } from "goi_common/src/design-system";
import { HERO_DEDUCT_ROWS } from "./sangjoLandingData";
import { Accent, Eyebrow, GraphicIcon } from "./SangjoLandingUI";

export default function SangjoLandingHero({
  onRequest,
  onCall,
}: {
  /** "예상 비용 1분 만에 받아보기" → /match/request */
  onRequest: () => void;
  onCall: () => void;
}) {
  return (
    <BaseStack width="100%" p="40px 20px 48px">
      <Eyebrow>상조를 알아보고 계신가요?</Eyebrow>
      <Spacing gap={8} />
      <Box className="title_2_b" color={baseColors.label_normal}>
        장례 비용, 미리 다 알려드리고
        <br />
        <Accent>쓴 만큼만</Accent> 내면 돼요
      </Box>

      <Spacing gap={36} />
      <BaseStack spacing={6}>
        <BaseStack direction="horizontal" spacing={6} alignItems="flex-start">
          <ColorIcon name="icon_normal_close" size={20} color={baseColors.status_negative} />
          <Box className="body_2_reading_r" color={baseColors.label_alternative_1}>
            정해진 상품에 장례를 맞추지 마세요.
          </Box>
        </BaseStack>
        <BaseStack direction="horizontal" spacing={6} alignItems="flex-start">
          <ColorIcon name="icon_normal_check" size={20} color={baseColors.status_positive} />
          <Box className="body_2_reading_r" color={baseColors.label_alternative_1}>
            고이는 내 상황에 필요한 항목으로 예상 비용을
            <br />
            먼저 안내하고, 실제로 쓴 만큼만 결제하면 돼요.
          </Box>
        </BaseStack>
      </BaseStack>

      <Spacing gap={32} />
      <EstimateCard />

      <Spacing gap={24} />
      <BaseStack spacing={8}>
        <BaseButton type="primary" size="large" onClick={onRequest}>
          <Box className="body_1_normal_m">예상 비용 1분 만에 받아보기</Box>
        </BaseButton>
        <BaseButton type="assistive_1" outlined size="large" onClick={onCall}>
          <BaseStack direction="horizontal" spacing={4} alignItems="center">
            <ColorIcon name="icon-call-mono" size={20} color={baseColors.label_alternative_1} />
            <Box className="body_1_normal_m">지금 장례가 필요하다면 24시간 전화</Box>
          </BaseStack>
        </BaseButton>
      </BaseStack>

      <Spacing gap={16} />
      <BaseStack direction="horizontal" spacing={6} justifyContent="center" alignItems="center">
        <GraphicIcon name="shield" size={20} />
        <Box className="label_1_m" color={baseColors.label_assistive_1}>
          20만 건의 장례 견적을 안내한 고이장례연구소
        </Box>
      </BaseStack>
    </BaseStack>
  );
}

const EstimateCard = () => (
  <BaseStack
    width="100%"
    p="20px"
    borderRadius="12px"
    border={`1px solid ${baseColors.line_normal}`}
  >
    <BaseStack
      direction="horizontal"
      spacing={12}
      alignItems="center"
      pb="16px"
      borderBottom={`1px solid ${baseColors.line_normal}`}
    >
      <GraphicIcon name="receipt" size={32} />
      <Box flex={1} minWidth={0}>
        <Box className="headline_3_sb" color={baseColors.label_normal}>
          고이 상조 예상 견적서
        </Box>
        <Box className="label_2_r" color={baseColors.label_assistive_1}>
          가족장 · 조문객 50~100명 기준
        </Box>
      </Box>
      <Box
        flexShrink={0}
        height="24px"
        px="8px"
        display="flex"
        alignItems="center"
        borderRadius="4px"
        bg={baseColors.fill_normal}
        className="label_2_sb"
        color={baseColors.label_assistive_1}
      >
        예시
      </Box>
    </BaseStack>

    <BaseStack direction="horizontal" justifyContent="space-between" alignItems="center" py="16px">
      <Box>
        <Box className="body_1_normal_sb" color={baseColors.label_normal}>
          기본 구성 비용
        </Box>
        <Box className="label_2_r" color={baseColors.label_assistive_1}>
          장례 인력 · 용품 · 차량
        </Box>
      </Box>
      <Box className="headline_3_sb" color={baseColors.label_normal}>
        289만원
      </Box>
    </BaseStack>

    <BaseStack p="16px" borderRadius="6px" bg={baseColors.background_accent_1} spacing={12}>
      <Box className="label_1_sb" color={baseColors.primary_orange}>
        사용하지 않는 품목은 빼고
      </Box>
      {HERO_DEDUCT_ROWS.map((row) => (
        <BaseStack key={row.label} direction="horizontal" justifyContent="space-between">
          <Box className="body_1_normal_m" color={baseColors.label_alternative_1}>
            {row.label}
          </Box>
          <Box className="body_1_normal_sb" color={baseColors.green_500}>
            {row.value}
          </Box>
        </BaseStack>
      ))}
    </BaseStack>

    <Spacing gap={16} />
    <BaseStack
      direction="horizontal"
      justifyContent="space-between"
      alignItems="flex-start"
      pt="16px"
      borderTop={`1px solid ${baseColors.line_normal}`}
    >
      <Box className="body_1_normal_sb" color={baseColors.label_normal}>
        예상 결제 금액
      </Box>
      <Box textAlign="right">
        <Box className="label_2_r" color={baseColors.green_500} textDecoration="line-through">
          289만원
        </Box>
        <Box className="title_3_b" color={baseColors.primary_orange}>
          235만원
        </Box>
        <Box className="label_2_m" color={baseColors.green_500}>
          미이용 항목 54만원 제외
        </Box>
      </Box>
    </BaseStack>

    <Spacing gap={12} />
    <Box className="label_2_r" color={baseColors.label_assistive_1}>
      금액은 예시이며, 실제 견적은 선택 항목에 따라 달라집니다.
    </Box>
  </BaseStack>
);
